import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";


import { DownloadTableExcel } from 'react-export-table-to-excel';

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

export default class ReportSparePartsMinimal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            data_search: "",
            start_date: format_date(new Date(), "yyyy-mm-dd", "en"), // Set current date as default
            end_date: format_date(new Date(), "yyyy-mm-dd", "en"), // Set current date as default
            
            // For grouping data
            grouped_data: {}
        }
        this.tableRef = React.createRef();
        this.exportPDF = this.exportPDF.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
    }
    
    async componentDidMount() {
        await this.GetReceiptList();
    }
    
    GetReceiptList = async () => {
        this.setState({ loading: true });

        // Format dates for API request
        const startDate = this.state.start_date ? this.state.start_date : "";
        const endDate = this.state.end_date ? this.state.end_date : "";
        
        let body = {
            page: 0,
            decision_status: 1,
            data_search: this.state.data_search,
            company_id: "", // No company filter in minimal report
            start_date: startDate,
            end_date: endDate
        }

        // Use the goods-receipt endpoint
        let result = await GET(tokens, "v1/TH/goods-receipt/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            // Get full details for each receipt
            const detailedData = [];
            for (const item of result.data) {
                const detailBody = {
                    page: "",
                    data_search: "",
                    g_rec_main_id: item.g_rec_main_id
                }
                const detailResult = await GET(tokens, "v1/TH/goods-receipt/list/" + getStorage("branch").branch_id, detailBody);
                if (detailResult && detailResult.status) {
                    detailedData.push(detailResult.data);
                }
            }
            console.log("Receipt data loaded:", detailedData.length, "items");
            this.setState({ data: detailedData });
            this.processData(detailedData);
        }
        this.setState({ loading: false });
    }
    
    // Process data to group by supplier
    processData = (data) => {
        let grouped = {};
        
        data.forEach(item => {
            // Use supplier name from the relation_company_supplier field
            const supplierName = item.relation_company_supplier ? 
                item.relation_company_supplier.company_name : "ไม่ระบุผู้ขาย";
            
            if (!grouped[supplierName]) {
                grouped[supplierName] = [];
            }
            
            grouped[supplierName].push(item);
        });
        
        this.setState({ grouped_data: grouped });
    }
    
    calculateTotals = (items) => {
        let totalAmount = 0;
        let totalDiscount = 0;
        let totalAfterDiscount = 0;
        let totalVat = 0;
        let grandTotal = 0;
        
        items.forEach(item => {
            // Use the receipt data structure for calculations
            const itemAmount = parseFloat(item.total_price) || 0;
            const itemDiscount = parseFloat(item.discount) || 0;
            const itemAfterDiscount = itemAmount - itemDiscount;
            const itemVat = parseFloat(item.vat) || 0;
            const itemTotal = parseFloat(item.total_price_final) || 0;
            
            totalAmount += itemAmount;
            totalDiscount += itemDiscount;
            totalAfterDiscount += itemAfterDiscount;
            totalVat += itemVat;
            grandTotal += itemTotal;
        });
        
        return {
            totalAmount,
            totalDiscount,
            totalAfterDiscount,
            totalVat,
            grandTotal
        };
    }
    
    calculateGrandTotals = () => {
        let overallTotalAmount = 0;
        let overallTotalDiscount = 0;
        let overallTotalAfterDiscount = 0;
        let overallTotalVat = 0;
        let overallGrandTotal = 0;
        
        Object.keys(this.state.grouped_data).forEach(supplierName => {
            const items = this.state.grouped_data[supplierName];
            const totals = this.calculateTotals(items);
            
            overallTotalAmount += totals.totalAmount;
            overallTotalDiscount += totals.totalDiscount;
            overallTotalAfterDiscount += totals.totalAfterDiscount;
            overallTotalVat += totals.totalVat;
            overallGrandTotal += totals.grandTotal;
        });
        
        return {
            overallTotalAmount,
            overallTotalDiscount,
            overallTotalAfterDiscount,
            overallTotalVat,
            overallGrandTotal
        };
    }
    
    exportPDF = () => {
        let table = [];
        
        // For each supplier and its items
        Object.keys(this.state.grouped_data).forEach((supplierName, supplierIndex) => {
            const items = this.state.grouped_data[supplierName];
            
            // Add supplier header
            table.push([
                { text: "ชื่อบริษัทคู่ค้า : " + supplierName, alignment: "center", fillColor: "#0F4C81", color: "#ffffff", colSpan: 8 },
                {}, {}, {}, {}, {}, {}, {}
            ]);
            
            // Add column headers
            table.push([
                { text: "ลำดับ", alignment: "center", fillColor: "#DCE5FF" },
                { text: "วันที่รับสินค้า", alignment: "center", fillColor: "#DCE5FF" },
                { text: "เลขที่ใบรับสินค้า", alignment: "center", fillColor: "#DCE5FF" },
                { text: "จำนวนเงินค่าสินค้า", alignment: "center", fillColor: "#DCE5FF" },
                { text: "ส่วนลด", alignment: "center", fillColor: "#DCE5FF" },
                { text: "ราคาหลังหักส่วนลด", alignment: "center", fillColor: "#DCE5FF" },
                { text: "ภาษีมูลค่าเพิ่ม", alignment: "center", fillColor: "#DCE5FF" },
                { text: "จำนวนเงินรวมทั้งสิ้น", alignment: "center", fillColor: "#DCE5FF" },
            ]);
            
            // Add data rows for this supplier
            items.forEach((item, itemIndex) => {
                table.push([
                    { text: (itemIndex + 1).toString(), alignment: "center" },
                    { text: format_date(item.receive_date, "dd/mm/yyyy", "th"), alignment: "center" },
                    { text: item.bill_receipt_code, alignment: "center" },
                    { text: toFixed(item.total_price), alignment: "right" },
                    { text: toFixed(item.discount), alignment: "right" },
                    { text: toFixed(item.total_price - item.discount), alignment: "right" },
                    { text: toFixed(item.vat), alignment: "right" },
                    { text: toFixed(item.total_price_final), alignment: "right" },
                ]);
            });
            
            // Calculate supplier totals
            const supplierTotals = this.calculateTotals(items);
            
            // Add supplier subtotal row
            table.push([
                { text: "รวม", alignment: "right", colSpan: 3, fillColor: "#f8f9fa" },
                {}, {},
                { text: toFixed(supplierTotals.totalAmount), alignment: "right", fillColor: "#f8f9fa" },
                { text: toFixed(supplierTotals.totalDiscount), alignment: "right", fillColor: "#f8f9fa" },
                { text: toFixed(supplierTotals.totalAfterDiscount), alignment: "right", fillColor: "#f8f9fa" },
                { text: toFixed(supplierTotals.totalVat), alignment: "right", fillColor: "#f8f9fa" },
                { text: toFixed(supplierTotals.grandTotal), alignment: "right", fillColor: "#f8f9fa" },
            ]);
        });
        
        // Add grand total row
        const grandTotals = this.calculateGrandTotals();
        table.push([
            { text: "ราคารวมทั้งหมด", alignment: "right", colSpan: 3, fillColor: "#6c757d", color: "#ffffff" },
            {}, {},
            { text: toFixed(grandTotals.overallTotalAmount), alignment: "right", fillColor: "#6c757d", color: "#ffffff" },
            { text: toFixed(grandTotals.overallTotalDiscount), alignment: "right", fillColor: "#6c757d", color: "#ffffff" },
            { text: toFixed(grandTotals.overallTotalAfterDiscount), alignment: "right", fillColor: "#6c757d", color: "#ffffff" },
            { text: toFixed(grandTotals.overallTotalVat), alignment: "right", fillColor: "#6c757d", color: "#ffffff" },
            { text: toFixed(grandTotals.overallGrandTotal), alignment: "right", fillColor: "#6c757d", color: "#ffffff" },
        ]);
        
        var docDefinition = {
            content: [
                { text: "รายงานการรับสินค้าแบบผลรวม", alignment: "left", fontSize: 24, bold: true },
                " ",
                {
                    table: {
                        headerRows: 0,
                        widths: ['5%', '12%', '18%', '13%', '13%', '13%', '13%', '13%'],
                        body: [
                            ...table
                        ],
                    }
                },
            ],
            defaultStyle: { font: "THSarabunNew", fontSize: 16, lineHeight: 1 },
            pageSize: "A4",
            pageMargins: [15, 15, 15, 15],
            pageOrientation: 'landscape',
        }
        
        pdfMake.createPdf(docDefinition).open();
    }
    
    // New Excel export function
    exportExcel = () => {
        try {
            // Create a new workbook
            const XLSX = require('xlsx');
            const wb = XLSX.utils.book_new();
            
            // All rows for the Excel file
            let rows = [];
            
            // Add title row
            rows.push(["รายงานการรับสินค้าแบบผลรวม"]);
            rows.push([]); // Empty row
            
            // For each supplier group
            Object.keys(this.state.grouped_data).forEach((supplierName, supplierIndex) => {
                const items = this.state.grouped_data[supplierName];
                
                // Add supplier header
                rows.push([`ชื่อบริษัทคู่ค้า : ${supplierName}`]);
                
                // Add column headers
                rows.push([
                    "ลำดับ", 
                    "วันที่รับสินค้า", 
                    "เลขที่ใบรับสินค้า", 
                    "จำนวนเงินค่าสินค้า", 
                    "ส่วนลด", 
                    "ราคาหลังหักส่วนลด", 
                    "ภาษีมูลค่าเพิ่ม", 
                    "จำนวนเงินรวมทั้งสิ้น"
                ]);
                
                // Add data rows for this supplier
                items.forEach((item, itemIndex) => {
                    rows.push([
                        itemIndex + 1,
                        format_date(item.receive_date, "dd/mm/yyyy", "th"),
                        item.bill_receipt_code,
                        parseFloat(item.total_price) || 0,
                        parseFloat(item.discount) || 0,
                        (parseFloat(item.total_price) || 0) - (parseFloat(item.discount) || 0),
                        parseFloat(item.vat) || 0,
                        parseFloat(item.total_price_final) || 0
                    ]);
                });
                
                // Calculate supplier totals
                const supplierTotals = this.calculateTotals(items);
                
                // Add supplier subtotal row
                rows.push([
                    "", "", "รวม",
                    supplierTotals.totalAmount,
                    supplierTotals.totalDiscount,
                    supplierTotals.totalAfterDiscount,
                    supplierTotals.totalVat,
                    supplierTotals.grandTotal
                ]);
                
                // Add empty row between supplier groups
                rows.push([]);
            });
            
            // Add grand total row
            const grandTotals = this.calculateGrandTotals();
            rows.push([
                "", "", "ราคารวมทั้งหมด",
                grandTotals.overallTotalAmount,
                grandTotals.overallTotalDiscount,
                grandTotals.overallTotalAfterDiscount,
                grandTotals.overallTotalVat,
                grandTotals.overallGrandTotal
            ]);
            
            // Create worksheet and add to workbook
            const ws = XLSX.utils.aoa_to_sheet(rows);
            XLSX.utils.book_append_sheet(wb, ws, "รายงานการรับสินค้า");
            
            // Generate Excel file
            XLSX.writeFile(wb, "รายงานการรับสินค้าแบบผลรวม.xlsx");
        } catch (error) {
            console.error("Error generating Excel:", error);
            alert("เกิดข้อผิดพลาดในการสร้างไฟล์ Excel: " + error.message);
        }
    }
    
    render() {
        const grandTotals = this.calculateGrandTotals();
        
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="รายงานการรับสินค้า" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>รายงานการรับสินค้าแบบผลรวม</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-success mx-1 border" onClick={this.exportExcel}>
                                    <span className="icon me-2">{"\uf1c3"}</span>Excel
                                </button>
                                <button className="btn btn-danger mx-1 border" onClick={this.exportPDF}>
                                    <span className="icon me-2">{"\uf1c1"}</span>PDF
                                </button>
                            </div>
                        </div>

                        <div className="w-100 card border-0 p-3 rounded-lg mb-3">
                            <div className="row mb-3">
                                <div className="col-12 col-md-4 mb-2">
                                    <label className="mb-2">ค้นหา:</label>
                                    <div className="input-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="ค้นหาเลขที่ใบรับ หรือ ชื่อบริษัท"
                                            onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                            onKeyUp={(e) => {
                                                if (e.key === "Enter") {
                                                    this.GetReceiptList();
                                                }
                                            }}
                                            value={this.state.data_search}
                                        />
                                        <span className="input-group-text bg-white">
                                            <span className="icon text-muted">{"\uf002"}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">วันที่เริ่มต้น:</label>
                                    <input
                                        className="form-control border"
                                        type="date"
                                        onChange={(e) => { this.setState({ start_date: e.target.value }) }}
                                        value={this.state.start_date}
                                    />
                                </div>
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">วันที่สิ้นสุด:</label>
                                    <input
                                        className="form-control border"
                                        type="date"
                                        onChange={(e) => { this.setState({ end_date: e.target.value }) }}
                                        value={this.state.end_date}
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                                    <button 
                                        className="btn btn-primary w-100" 
                                        onClick={this.GetReceiptList}>
                                        <span className="icon me-2">{"\uf002"}</span>ค้นหา
                                    </button>
                                </div>
                            </div>

                            <div className="rounded border overflow-hidden">
                                <div className="table-responsive" ref={this.tableRef}>
                                    <table className="table table-bordered mb-0">
                                        <thead>
                                            <tr className="bg-primary text-white">
                                                <th className="text-center">ลำดับ</th>
                                                <th className="text-center">วันที่รับสินค้า</th>
                                                <th className="text-center">เลขที่ใบรับสินค้า</th>
                                                <th className="text-center">จำนวนเงินค่าสินค้า</th>
                                                <th className="text-center">ส่วนลด</th>
                                                <th className="text-center">ราคาหลังหักส่วนลด</th>
                                                <th className="text-center">ภาษีมูลค่าเพิ่ม</th>
                                                <th className="text-center">จำนวนเงินรวมทั้งสิ้น</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.keys(this.state.grouped_data).map((supplierName, supplierIndex) => {
                                                const items = this.state.grouped_data[supplierName];
                                                const supplierTotals = this.calculateTotals(items);
                                                
                                                return (
                                                    <React.Fragment key={supplierIndex}>
                                                        <tr className="bg-light">
                                                            <td colSpan="8" className="py-2">
                                                                <strong>ชื่อบริษัทคู่ค้า: {supplierName}</strong>
                                                            </td>
                                                        </tr>
                                                        
                                                        {items.map((item, itemIndex) => (
                                                            <tr key={itemIndex}>
                                                                <td className="text-center">{itemIndex + 1}</td>
                                                                <td className="text-center">{format_date(item.receive_date, "dd/mm/yyyy", "th")}</td>
                                                                <td className="text-center">{item.bill_receipt_code}</td>
                                                                <td className="text-end">{toFixed(item.total_price)}</td>
                                                                <td className="text-end">{toFixed(item.discount)}</td>
                                                                <td className="text-end">{toFixed(item.total_price - item.discount)}</td>
                                                                <td className="text-end">{toFixed(item.vat)}</td>
                                                                <td className="text-end">{toFixed(item.total_price_final)}</td>
                                                            </tr>
                                                        ))}
                                                        
                                                        {/* Subtotal for this supplier */}
                                                        <tr className="bg-light">
                                                            <td colSpan="3" className="text-end pe-3"><strong>รวม</strong></td>
                                                            <td className="text-end">{toFixed(supplierTotals.totalAmount)}</td>
                                                            <td className="text-end">{toFixed(supplierTotals.totalDiscount)}</td>
                                                            <td className="text-end">{toFixed(supplierTotals.totalAfterDiscount)}</td>
                                                            <td className="text-end">{toFixed(supplierTotals.totalVat)}</td>
                                                            <td className="text-end">{toFixed(supplierTotals.grandTotal)}</td>
                                                        </tr>
                                                    </React.Fragment>
                                                );
                                            })}
                                        </tbody>
                                        {/* Grand Total */}
                                        <tfoot>
                                            <tr className="bg-secondary text-white">
                                                <td colSpan="3" className="text-end pe-3"><strong>ราคารวมทั้งหมด</strong></td>
                                                <td className="text-end">{toFixed(grandTotals.overallTotalAmount)}</td>
                                                <td className="text-end">{toFixed(grandTotals.overallTotalDiscount)}</td>
                                                <td className="text-end">{toFixed(grandTotals.overallTotalAfterDiscount)}</td>
                                                <td className="text-end">{toFixed(grandTotals.overallTotalVat)}</td>
                                                <td className="text-end">{toFixed(grandTotals.overallGrandTotal)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}